<template lang="pug">
  v-dialog(
    :value="value"
    @input="close"
    max-width="600px"
  )
    v-card
      v-card-title.headline
        slot(name="header") Подтверждение
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
      v-card-text(class="dialog-text")
        slot(name="body") Вы подтверждаете действие?
      v-divider
      v-card-actions
        slot(name="actions")
          v-spacer
          v-btn(
            color="error"
            @click="emitConfirm"
            :loading="loading"
            text rounded
          ) Да
          v-btn(color="warning" @click="close" text rounded) Нет

</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  methods: {
    emitConfirm() {
      this.$emit('confirm');
    },
    close() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .dialog-text {
    font-size: 1rem;
  }

</style>
